module.exports = __webpack_public_path__ + "img/725b65d10267c775c9675b3532f149c0.png";


//////////////////
// WEBPACK FOOTER
// ./classes/heroes/seb/assets/sprites/seb_06.png
// module id = 63
// module chunks = 0